import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../components/Hero";
import { MarqueeStrip } from "../components/MarqueeStrip";
import { About } from "../components/About";
import { FeaturedDishes } from "../components/FeaturedDishes";
import { Wine } from "../components/Wine";
import { Gallery } from "../components/Gallery";
import { Reviews } from "../components/Reviews";
import { Reserve } from "../components/Reserve";
import { Contact } from "../components/Contact";
import { scrollToId } from "../scroll";

export default function Home() {
  const { state } = useLocation();
  useEffect(() => {
    if (state?.scrollTo) {
      const id = state.scrollTo;
      const timer = setTimeout(() => scrollToId(id), 250);
      return () => clearTimeout(timer);
    }
  }, [state]);

  return (
    <>
      <Hero />
      <MarqueeStrip />
      <About />
      <FeaturedDishes />
      <Wine />
      <Gallery />
      <Reviews />
      <Reserve />
      <Contact />
    </>
  );
}
